import { Tab, TabProps, Tabs, TabsProps, styled } from '@mui/material';

export const PillTabs = styled((props: TabsProps) => (
    <Tabs {...props} TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }} />
))(({ theme }) => ({
    backgroundColor: theme.palette.backgroundMainLayout.main,
    borderRadius: 10,
    minHeight: 44,
    zIndex: 1,
    display: 'inline-flex',
    '& .MuiTabs-indicator': {
        top: 3,
        bottom: 3,
        right: 3,
        height: 'auto',
        background: 'none',
        '&:after': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 4,
            right: 4,
            bottom: 0,
            borderRadius: 8,
            backgroundColor: '#fff',
            boxShadow: '0 4px 12px 0 rgba(0,0,0,0.16)',
        },
    },
    '& .MuiTabs-indicatorSpan': {},
    '& MuiTabs-scroller': {
        with: 'auto',
    },
}));

export const PillTab = styled((props: TabProps) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        //textTransform: 'none',
        minWidth: 0,
        [theme.breakpoints.up('sm')]: {
            minWidth: 0,
        },
        //fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(1),
        color: 'rgba(0, 0, 0, 0.85)',
        zIndex: 2,
        '&:hover': {
            //color: '#40a9ff',
            opacity: 1,
        },
        '&.Mui-selected': {
            //color: '#1890ff',
            //fontWeight: theme.typography.fontWeightMedium,
        },
        '&.Mui-focusVisible': {
            backgroundColor: '#d1eaff',
        },
        '&:last-child': {
            marginRight: 0,
        },
    }),
);
